<template>
  <div>
  </div>
</template>

<script>
import Swal from "sweetalert2"; // Keep capital - Swal.fire() works

import { mapActions, mapGetters } from "vuex";

const TOTAL_SESSION_DURATION_MINUTES = process.env.VUE_APP_SESSION_TIMEOUT_MINUTES; 

export default {
  name: "SessionTimeOutModalManager",
  data() {
    const modalCountdownDurationMinutes = TOTAL_SESSION_DURATION_MINUTES / 2;
    const initialModalCountdownMs = modalCountdownDurationMinutes * 60 * 1000;

    return {
      sesssionPopupDisplayed: false,
      countdownTime: initialModalCountdownMs,
      initialCountdownMs: initialModalCountdownMs,
      timerRef: 0,
      sessionLogoutMessageRef: null,
      showCancelButtonStatus: true,
      sessionLogoutWarning: `Your session is about to expire in <b></b>. AGATRS was idle for ${modalCountdownDurationMinutes} minutes.`,
      sessionEndedMessage: `Your session has expired after ${TOTAL_SESSION_DURATION_MINUTES} minutes of inactivity.`,
      modalDisplayTriggerMinutes: modalCountdownDurationMinutes,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
    }),
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    formatCountdownTimer() {
      if (this.countdownTime > 0) {
        return new Date(this.countdownTime).toISOString().slice(14, -5);
      }
      return "00:00";
    },
  },
  watch: {
    isIdle(value, oldValue) {
      //console.log('Watcher: isIdle changed to:', value,
                    //'isLoggedIn:', this.isLoggedIn,
                    //'sesssionPopupDisplayed:', this.sesssionPopupDisplayed,
                    //'countdownTime:', this.countdownTime);

      if (value) {
        if (this.isLoggedIn && !this.sesssionPopupDisplayed && this.countdownTime >= 1000) {
          //console.log(`Watcher: User idle for ${this.modalDisplayTriggerMinutes} mins. Conditions MET to show warning. Calling showSessionWarning().`);
          this.sesssionPopupDisplayed = true;
          this.showSessionWarning();
        } else {
            // console.log('Watcher: Conditions NOT MET to show warning when idle.', 
            // {
            //     isLoggedIn: this.isLoggedIn,
            //     sesssionPopupDisplayed: this.sesssionPopupDisplayed,
            //     countdownTime: this.countdownTime
            // });
        }
      } else {
        if (oldValue === true) {
          //console.log('USER ACTIVITY DETECTED: Idle state ended.');
        }
        if (!this.sesssionPopupDisplayed) {
          // console.log('Watcher: User active and popup NOT displayed. Clearing timer.');
          this.clearCountdownTimer();
        } else {
            // console.log('Watcher: User active but popup IS displayed. User interaction with modal will handle it.');
        }
      }
    },
  },
  methods: {
    ...mapActions({
      restoreContext: "authentication/restoreContext",
      clearAllLogoutData: "authentication/clearAllLogoutData",
    }),
    decrementCountdownTimer() {
      if (this.countdownTime > 1000) {
        this.countdownTime = this.countdownTime - 1000;
        //console.log(`Ticker: Session warning countdown: ${this.formatCountdownTimer}`);
        
        // Use .swal2-html-container 
        const swalHtmlContainer = document.querySelector('.swal2-html-container'); 
        if (swalHtmlContainer) {
            const boldTag = swalHtmlContainer.querySelector("b");
            if (boldTag) {
                boldTag.innerHTML = this.formatCountdownTimer;
            }
        }
      } else {
        //console.log('Countdown reached zero. Session expired.');
        const swalHtmlContainer = document.querySelector('.swal2-html-container');
        if (swalHtmlContainer) {
          swalHtmlContainer.innerHTML = this.sessionEndedMessage; // This replaces the countdown HTML
        }

        const confirmButton = document.querySelector(".swal2-confirm");
        const cancelButton = document.querySelector(".swal2-cancel");

        if (confirmButton) {
          confirmButton.style.display = "none";
        }
        if (cancelButton) {
          cancelButton.innerHTML = "Return To Login";
          cancelButton.style.display = "inline-block";
        }
        
        clearInterval(this.timerRef);
        this.timerRef = 0;

        if (this.isLoggedIn) {
            this.clearAllLogoutData();
        }
      }
    },
    clearCountdownTimer() {
      //console.log('clearCountdownTimer called. Stopping timerRef:', this.timerRef);
      clearInterval(this.timerRef);
      this.timerRef = 0;
      this.sesssionPopupDisplayed = false;
      this.countdownTime = this.initialCountdownMs;
      // console.log('clearCountdownTimer: sesssionPopupDisplayed reset to false, countdownTime reset to', this.countdownTime);
    },
    showSessionWarning() {
      // console.log('showSessionWarning called. Using Swal.fire() with didOpen.');

      if (typeof Swal.isVisible === 'function' && Swal.isVisible()) {
        Swal.close();
      }
      
      try {
        this.sessionLogoutMessageRef = Swal.fire({ 
          title: "Session Expiration Warning",
          html: `${this.sessionLogoutWarning.replace('<b></b>', `<b>${this.formatCountdownTimer}</b>`)}`,
          icon: "warning", 
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: this.showCancelButtonStatus,
          confirmButtonColor: "#10b45a",
          cancelButtonColor: "red",
          cancelButtonText: "Logout",
          confirmButtonText: "Continue",
          reverseButtons: false,
          didOpen: (_modalElement) => { 
            //console.log('SweetAlert didOpen callback. Starting interval.');
            if (this.timerRef === 0) {
              this.timerRef = setInterval(() => {
                this.decrementCountdownTimer();
              }, 1000);
              // console.log('Interval started. timerRef:', this.timerRef);
            } else {
              // console.log('Interval already running or not reset. timerRef:', this.timerRef);
            }
          }
        }).then((result) => {
          //console.log('SweetAlert closed. Result:', result);
          this.clearCountdownTimer(); 

          if (result.dismiss && (result.dismiss === Swal.DismissReason.cancel || result.dismiss === 'cancel')) {
            // console.log('User dismissed/logged out via modal button.');
            if (this.isLoggedIn) {
              this.clearAllLogoutData();
            }
          } else if (result.isConfirmed) { 
            // console.log('User clicked Continue. Restoring context.');
            this.restoreContext()
              .then(() => {
                // console.log('Context restored successfully.');
              })
              .catch(error => {
                console.error("Failed to restore context:", error);
                if (this.isLoggedIn) {
                  this.clearAllLogoutData();
                }
                // Error icon needs to be different
                Swal.fire({
                    title: "Session Renewal Failed",
                    text: "Could not renew your session. Please log in again.",
                    icon: "error" // Distinct icon
                });
              });
          } else if (result.isDismissed) { 
              //console.log('SweetAlert dismissed for other reason. Reason:', result.dismiss);
          }
        }).catch(err => {
            // console.error("Error with SweetAlert promise (Swal.fire):", err);
            this.clearCountdownTimer(); 
        });
      } catch (e) {
        // console.error("Error directly invoking 'Swal.fire()':", e); 
        this.sesssionPopupDisplayed = false; 
      }
    },
  },
};
</script>

<style scoped>
/* Scoped styles for the SessionTimeOutModalManager */
</style>